import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AppState, stateGetter } from "../../store/state/app.state";
import { Store } from "@ngrx/store";
import { Subject } from "rxjs";
import { faHourglassStart } from "@fortawesome/free-solid-svg-icons";

import { LabAccess, LabsPageService } from "../labs-page.service";

import { ModalEditAccessComponent } from "../modal-edit-access/modal-edit-access.component";
import { NzModalService } from "ng-zorro-antd/modal";
import { NzMessageService } from "ng-zorro-antd/message";

import {
  VAIconRegistryService,
  checkCircle,
  check,
  exclamationTriangle,
  arrowCircleRight,
  arrowCircleLeft
} from "@va/core-library/icons";

@Component({
  selector: "app-labs-dashboard",
  templateUrl: "./labs-dashboard.component.html",
  styleUrls: ["./labs-dashboard.component.scss"],
  host: { class: "labs-dashboard-component" },
})
export class LabsDashboardComponent implements OnInit, OnDestroy {
  public accessLoadComplete = false;
  public firmLabsAccess: LabAccess;
  public isUserLabsAccess = false;
  public reportTypeList: any[] = [];
  public reportList: any[] = [];
  public accessType: any;
  public valabsConfig: any = {};
  public selectedType = "";
  public selectedReport = 0;
  public snapEmail = "";
  public userName = "";
  faHourglassStart = faHourglassStart;

  constructor(
    public labsPageService: LabsPageService,
    private router: Router,
    private store: Store<AppState>,
    private modalService: NzModalService,
    private message: NzMessageService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([checkCircle, check, exclamationTriangle, arrowCircleLeft, arrowCircleRight]);
    store
      .select(stateGetter("globalHeader", "globalSettings"))
      .subscribe((data: any) => {
        this.snapEmail = data.userDetails ? data.userDetails.email : "";
        this.userName = data.userName;
      });
  }

  async ngOnInit() {
    this.labsPageService.checkCompleteSubject = new Subject<any>();
    this.labsPageService.checkCompleteSubject.subscribe(() => {
      if (
        "menuOption" in this.labsPageService.labsUser.is_data_check &&
        "globalSettings" in this.labsPageService.labsUser.is_data_check
      ) {
        //this.initPageLoad();
        this.accessLoadComplete = true;

        if (this.labsPageService.labsUser.is_lab_access) {
          this.initLabsPages();
        } else {
          this.router.navigate([`/home`]);
        }
      }
    });
    await this.labsPageService.initLabsUser(this.store);
  }

  ngOnDestroy(): void {
    this.labsPageService.checkCompleteSubject.unsubscribe();
  }

  public selectReportType(id) {
    if (this.isUserLabsAccess) {
      if (id !== this.selectedReport) {
        const selectedItem = this.reportTypeList.find((x) => x.id === id);
        if (
          selectedItem.name !== "Prod" &&
          this.accessType.userAccess !== selectedItem.name
        ) {
          this.updateUserAccessDirect(selectedItem.name);
        } else {
          this.selectedReport = selectedItem.id;
          this.selectedType = selectedItem.name;
        }
      }
    }
  }

  initLabsPages() {
    const navParams = this.labsPageService.labsPagesParams;
    this.labsPageService
      .getLabsUrls("", navParams, "lab")
      .subscribe((response) => {
        this.reportList = this.labsPageService.getReportList(response);
      });

    this.labsPageService.getLabsData().subscribe((response) => {
      this.reportTypeList = response.reportType;
      this.selectedType = this.reportTypeList[0].name;
      this.accessType = response.aceessType;
      this.valabsConfig = response.labConfig;
      this.firmLabsAccess = this.accessType.firmAccess;
      this.isUserLabsAccess =
        this.accessType.userAccess === LabAccess.NONE ? false : true;
      this.selectedType = this.accessType.userAccess;
      this.selectedReport = this.reportTypeList.find(
        (x) => x.name === this.accessType.userAccess,
      ).id;
    });
  }

  public editAccess() {
    const modal = this.modalService.create({
      nzTitle: "Change Your Access Level",
      nzClosable: false,
      nzContent: ModalEditAccessComponent,
      nzComponentParams: {
        data: {
          reportType: this.reportTypeList,
          accessType: this.accessType,
        },
      },
    });
    modal.afterClose.subscribe((res) => {
      if (res !== undefined) {
        if (res.status === "success") {
          // Update user access level after success
          if (res.type === "update") {
            this.accessType.userAccess = res.accessType;
            const selectedItem = this.reportTypeList.find(
              (x) => x.name === res.accessType,
            );
            this.selectedReport = selectedItem.id;
            this.selectedType = res.accessType;
            this.accessType.userAccess = res.accessType;
          }
          this.showSuccesss(res.message);
        }
        if (res.status === "error") {
          this.showError(res.message);
        }
      }
    });
  }

  public checkUserAccessContains(accessType: string, userAccess: string) {
    return userAccess.includes(accessType);
  }

  public changeUserAccess(isLabAccess: boolean) {
    const accessType = isLabAccess
      ? this.accessType.firmAccess
      : LabAccess.NONE;
    this.labsPageService.updateUserAccess(accessType).subscribe((res) => {
      this.initAfterUpdate(accessType, res);
      if (res.status === "error") {
        this.isUserLabsAccess = !isLabAccess;
      }
    });
  }

  public updateUserAccessDirect(accessType: any) {
    this.labsPageService.updateUserAccess(accessType).subscribe((res) => {
      this.initAfterUpdate(accessType, res);
    });
  }

  public initAfterUpdate(accessType: any, res: any) {
    if (res.status === "success") {
      this.accessType.userAccess = accessType;
      const selectedItem = this.reportTypeList.find(
        (x) => x.name === accessType,
      );
      this.selectedReport = selectedItem !== undefined ? selectedItem.id : 0;
      this.selectedType = accessType;
      if (accessType !== "None" && selectedItem !== undefined) {
        this.showSuccesss(
          `Your access has been change to level ${selectedItem.level}: ${selectedItem.displayname}`,
        );
        this.labsPageService
          .getLabsUrls("", {}, "lab")
          .subscribe((response) => {
            this.reportList = this.labsPageService.getReportList(response);
          });
      } else {
        this.showSuccesss(`Your access has been change to None`);
      }
    }
    if (res.status === "error") {
      this.showError(res.message);
    }
  }

  public showSuccesss(msg: string) {
    this.message.success(msg, {
      nzDuration: 5000,
    });
  }

  public showError(msg: string) {
    this.message.error(msg, {
      nzDuration: 5000,
    });
  }
  public sendAccessRequest() {
    window.Usersnap.init({
      button: { isHidden: true },
    });
    window.Usersnap.on("open", (event) => {
      event.api.setValue("custom", {
        email: `##${this.snapEmail}##`,
        username: this.userName,
      });
      event.api.setValue("email", this.snapEmail);
      event.api.setValue("comment", "Requesting access to VA Labs");
    });
    setTimeout(function () {
      window.Usersnap.open();
    }, 500);
  }
}
